import React, { FC, useState, useEffect, useCallback } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonContent, createAnimation } from '@ionic/react'
import { memberMobx } from 'mobx/mkt'
import { format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { each, keyBy } from '@dt/fe-utils/dist/lodash'
import { CouponItem, UseHeader, MktFooter, CouponDetail, MktConfirmModal } from '@cps'
import { CdShow, DetailProgress } from 'pages/mkt/components'
import { Stepper } from 'components'
import { ActivityAPI } from 'api/index'
import RedeemSDK from 'sdk/redeem'
import './index.scss'

import defaultImg from '@img/mkt/default-redeem.jpg'
import { advertMobx } from '@mobxStore'

interface IProps {
  info: any;
  cardInfo: any;
  reject?: () => void;
  resolve?: (data: any) => void;
}

const ProductDetail: FC<IProps> = (props: IProps) => {
  const {
    info,
    cardInfo,
    reject,
    resolve,
  } = props
  const enterAnimation = (baseEl: any) => {
    const backdropAnimation = createAnimation()
      .addElement(baseEl.querySelector('ion-backdrop'))
      .fromTo('opacity', '0.01', 'var(--backdrop-opacity)')
    const wrapperAnimation = createAnimation()
      .addElement(baseEl.querySelector('.modal-wrapper'))
      .duration(150)
      .keyframes([
        { offset: 0, opacity: '0', transform: 'translateX(50%)' },
        { offset: 1, opacity: '1', transform: 'translateX(0)' },
      ])
    return createAnimation()
      .addElement(baseEl)
      .easing('ease-out')
      .duration(150)
      .addAnimation([backdropAnimation, wrapperAnimation])
  }
  const leaveAnimation = (baseEl: any) => {
    return enterAnimation(baseEl).direction('reverse')
  }
  const [cnt, setCnt] = useState<number>(1)
  const [price, setPrice] = useState<number>(0)
  const [statusInfo, setStatusInfo] = useState<any>({})
  const [scrollTop, setScrollTop] = useState<number>(0)
  const [couponMap, setCouponMap] = useState<any>({})
  // 1 可购买 2 库存不足 3 积分不足
  const [status, setStatus] = useState<number>(1)
  const getLen = () => {
    let len: number = 0
    each(info.coupons, (item: any) => {
      len += item.couponCnt
    })
    return len * cnt
  }
  // 手动加减数量
  const handleChangeCnt = useCallback((isAdd: boolean) => {
    setCnt(prev => isAdd ? prev + 1 : prev - 1)
  }, [cnt])
  const handleEditCnt = useCallback((value: number) => {
    setCnt(value)
  }, [cnt])
  const buyProduct = () => {
    modalLayer(MktConfirmModal, { title: i18n.t('mkt.redeem.pointsRedSure'), content: i18n.t('mkt.redeem.pointsRedText', { price: price, name: info.productName }) }).then(() => {
      realBuy()
    }, () => { })
  }
  const realBuy = () => {
    memberMobx.buyRedeemProduct({
      memberCardId: cardInfo.memberCardId,
      redeemProductId: info.redeemProductId,
      cnt,
    }).then((res: any) => {
      if (res.error) {
        resolve(res)
      } else {
        resolve({
          name: info.productName,
          cnt: getLen()
        })
      }
    })
  }
  const initData = () => {
    setStatusInfo(RedeemSDK.getInfo(info))
  }
  useEffect(() => {
    setPrice(info.productIntegral * cnt)
  }, [cnt])
  useEffect(() => {
    if (info) {
      initData()
      const couponIds: any[] = []
      each(info.coupons, (item: any) => {
        if (!couponIds.includes(item.couponId)) {
          couponIds.push(item.couponId)
        }
      })
      ActivityAPI.getCouponsList({
        couponIds: couponIds
      }).then((res: any) => {
        if (!res.error) {
          setCouponMap(keyBy(res, 'couponId'))
        }
      })
    }
  }, [info])
  useEffect(() => {
    if (statusInfo.remainCnt !== -1 && cnt > statusInfo.remainCnt) {
      setStatus(2)
      return
    }
    if (statusInfo.stockCnt !== -1 && cnt > statusInfo.stockCnt) {
      setStatus(2)
      return
    }
    if (cardInfo.integral < price) {
      setStatus(3)
      return
    }
    setStatus(1)
  }, [statusInfo, cnt, price])
  const showExpireTime = statusInfo.expired > 0 && statusInfo.expired <= 3
  const hasSoldOut = statusInfo.status === 2 // 商品售磬
  const showSoldNum = !hasSoldOut && memberMobx?.brandConfig?.isShowRedeemIntegralSale // 商品已售数量
  return (
    <IonModal
      cssClass='pro-detail-modal'
      isOpen
      showBackdrop
      backdropDismiss
      onDidDismiss={reject}
      enterAnimation={enterAnimation}
      leaveAnimation={leaveAnimation}
    >
      {scrollTop > 100 && <UseHeader title={info.productName} onBack={() => reject()} animation> </UseHeader>}
      {
        scrollTop <= 100 &&
          <div data-cypid='mmgRedeemDetailBack' className='top-back' onClick={reject}>
            <i className='iconfont icon-BACK-12x'></i>
          </div>
      }
      <IonContent
        class='modal-content'
        scrollEvents
        forceOverscroll
        onIonScroll={(e: any) => {
          setScrollTop(e.detail.scrollTop)
        }}
      >
        <div className='modal-top'>
          <div className='top-area' style={{ backgroundImage: `Url(${info.productImg || defaultImg})` }}></div>
        </div>
        <div className='pro-con'>
          {![5, 6].includes(statusInfo.status) &&
            <div className='top-time'>
              <DetailProgress rate={statusInfo.saleRate}></DetailProgress>
              <div className='bar-info'>
                <div className='left'>
                  <span className='left-text'>
                    {statusInfo.status === 0 && i18n.t('mkt.redeem.timeRob', { time: format.toTime(statusInfo.saleStart) })}
                    {statusInfo.status === 1 && i18n.t('mkt.redeem.panicBuying')}
                    {statusInfo.status === 2 && i18n.t('mkt.redeem.soldOut')}
                    {statusInfo.status === 3 && i18n.t('mkt.redeem.nextGrabbing')}
                    {statusInfo.status === 4 && i18n.t('mkt.redeem.endThisRound')}
                    {/* {statusInfo.status === 5 && `${i18n.t('mkt.redeem.sold')} ${statusInfo.type === 0 ? statusInfo.allSaleCnt : statusInfo.saleCnt}`} */}
                  </span>
                  {/* 待售 在售 售罄(不是总量售卖) 本轮结束(可售卖) */}
                  {
                    statusInfo.status === 0 || statusInfo.status === 1 || (statusInfo.status === 2 && statusInfo.type === 2) || statusInfo.status === 3
                      ? (
                        <div className='left-time'>
                          <CdShow
                            time={statusInfo.cdTime} onEnd={() => {
                              initData()
                            }}
                            onlyTime={false}
                          >
                          </CdShow>
                        </div>) : ''
                  }
                </div>
                <div className='right'>
                  {
                    statusInfo.type !== 0
                      ? (
                        <>
                          {statusInfo.status === 0 || statusInfo.status === 3 ? i18n.t('mkt.redeem.limitSaleCnt', { cnt: statusInfo.stockCnt }) : ''}
                          {statusInfo.status === 2 && i18n.t('mkt.redeem.endThisRound')}
                          {statusInfo.status === 1 && i18n.t('mkt.redeem.onlyLeftCnt', { cnt: statusInfo.remainCnt })}
                          {[4, 5].includes(statusInfo.status) &&
                            <>
                              {
                                statusInfo.expired > 0 && statusInfo.expired <= 3 ? i18n.t('mkt.redeem.someDaysOff', { day: statusInfo.expired }) : ''
                              }
                            </>}
                        </>)
                      : (
                        <>
                          {statusInfo.status === 3 && i18n.t('mkt.redeem.endThisRound')}
                          {/* {statusInfo.status !== 3 &&
                            <>
                              {
                                statusInfo.expired > 0 && statusInfo.expired <= 3 ? i18n.t('mkt.redeem.someDaysOff', { day: statusInfo.expired }) : ''
                              }
                            </>} */}
                        </>)
                  }
                </div>
              </div>
            </div>}
          <div className='top-info-container'>
            <div className='top-info'>
              <div className='name'>{info.productName}</div>
              {
                (showExpireTime || showSoldNum) &&
                  <div className='sale'>
                    {showSoldNum && (
                      `${i18n.t('mkt.redeem.sold')} ${statusInfo.type === 0 ? statusInfo.allSaleCnt : statusInfo.saleCnt}`
                    )}
                    {showExpireTime && `${showSoldNum ? '，' : ''}${i18n.t('mkt.redeem.someDaysOff', { day: statusInfo.expired })}`}
                  </div>
              }
              <div className='price'>
                <div className='price-info'>
                  <span className='integral'>{info.productIntegral}</span>
                  <span className='inter-text'>{i18n.t('mkt.common.integral')}</span>
                </div>
                {info.personLimit && <div className='limit-text'>{i18n.t('mkt.groupBuy.singleLimit', { num: info.personLimit })}</div>}
              </div>
            </div>
            {
              info.coupons && info.coupons.map((item: any) => {
                const couponInfo: any = couponMap[item.couponId]
                if (couponInfo) {
                  return (
                    <div className='coupon-block' key={item.couponId}>
                      <CouponItem
                        type='get'
                        cnt={item.couponCnt}
                        couponInfo={couponInfo}
                        onDetail={() => {
                          modalLayer(CouponDetail, { type: 'get', couponInfo: couponInfo }, 'couponDetail')
                        }}
                      >
                      </CouponItem>
                    </div>)
                }
              })
            }
            {
              info.productIntroduction &&
                <>
                  <div className='title'>{i18n.t('mkt.redeem.productContent')}</div>
                  <div className='intro'>{info.productIntroduction}</div>
                </>
            }
          </div>
        </div>
      </IonContent>
      {/* 在售 全时段售卖 */}
      {
        statusInfo.status === 1 || statusInfo.status === 5
          ? (
            <MktFooter className='footer-btn-wrap '>
              <div className='handle-price'>
                <Stepper size='large' min={1} max={999} cnt={cnt} onChange={handleChangeCnt} onEdit={handleEditCnt} />
              </div>
              <div
                data-cypid='mmgBuyRedeem'
                className={`add-cart ${status !== 1 ? 'disable' : ''}`}
                onClick={() => {
                  if (status !== 1) return
                  buyProduct()
                }}
              >
                {status === 1 && <div>{i18n.t('mkt.redeem.paySomePoints', { price: price })}</div>}
                {status === 3 &&
                  <>
                    <div className='small-tip'>{i18n.t('mkt.redeem.paySomePoints', { price: price })}</div>
                    <div>{i18n.t('mkt.redeem.notEnoughPoints')}</div>
                  </>}
                {status === 2 && <div>{i18n.t('mkt.redeem.insuGoods')}</div>}
              </div>
            </MktFooter>) : ''
      }
    </IonModal>
  )
}

export default observer(ProductDetail)
